import { useSearchParams } from 'react-router'
import { isDct, isSSOEnabled } from 'src/utils/env'

import { ssoLoginParam } from '../utils/loginPathWithSSOParam'

/**
 * ログイン画面にSSOログインボタンを表示するかどうかを判定する。
 *
 * dctではSSOを利用する組織のユーザーにしか導線を見せないため、`?login=sso`が付いている
 * ときだけ表示する。stage1/2/3・localはQAや開発でボタンを使うため常時表示する。
 *
 * SSOが設定されていない環境（`VITE_COGNITO_IDP_NAME`が空）では常に非表示にする。
 * この判定を省くと`signInWithRedirect`に空のプロバイダ名を渡す壊れたボタンが出てしまう。
 */
export const useShowSSOLoginButton = (): boolean => {
  const [searchParams] = useSearchParams()

  if (!isSSOEnabled()) return false
  if (!isDct()) return true

  return searchParams.get(ssoLoginParam.name) === ssoLoginParam.value
}
